var HORIZONTAL_ALIGN = {
  LEFT: 'flex-start',
  CENTER: 'center',
  RIGHT: 'flex-end'
};
export default HORIZONTAL_ALIGN;